import * as Sentry from '@sentry/react';

/**
 * Top-level error boundary.
 *
 * The app had none: `main.jsx` renders `<App />` bare and `<Suspense>` does
 * not catch render throws, so ONE throw during render unmounted the whole
 * root and left a blank page (ORDER-THISWAY-21's `React.lazy` TypeError and
 * ORDER-THISWAY-24's storage SecurityError both ended that way).
 *
 * This does not fix either bug — it bounds the blast radius of the next one:
 * a render error degrades to a recoverable screen, and Sentry still gets the
 * event (a boundary-caught error is not re-thrown to `window.onerror` in
 * React 18 production builds, so the capture has to come from here).
 */
const ErrorFallback = () => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
    <h1 className="text-lg font-semibold text-gray-900">
      Something went wrong
    </h1>
    <p className="mt-2 text-sm text-gray-500">
      The page could not be displayed. Reloading usually fixes it.
    </p>
    <button
      type="button"
      className="mt-5 rounded-lg bg-[var(--accent,#0A1034)] px-5 py-2.5 text-sm font-medium text-white"
      onClick={() => window.location.reload()}
    >
      Reload
    </button>
  </div>
);

const AppErrorBoundary = ({ children }) => (
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    {children}
  </Sentry.ErrorBoundary>
);

export default AppErrorBoundary;
